// import { Link } from 'react-router-dom'
// import CleanEnergyMineralIcon from '../../icons/CleanEnergyMineralIcon'
// import IndustrialMineralsIcon from '../../icons/IndustrialMineralsIcon'
// import SecurityMineralIcon from '../../icons/SecurityMineralIcon'



// export default function HomeOverviewGridCard({ title, image, clean_energy_item, industrial_item, security_item, icon }) {
//   return (
//     <div
//       data-aos="fade-down"
//       className="border-primary-600 group relative col-span-12 h-[360px] overflow-hidden border-2 sm:col-span-6 lg:col-span-3 lg:h-[260px]"
//     >
//       <img
//         src={image}
//         alt={title}
//         className="absolute h-full w-full object-cover transition duration-300 ease-in-out group-hover:scale-110"
//       />
//       <div className="from-primary-600 group-hover:to-primary-600/45 group-hover:via-primary-600/70 absolute h-full w-full bg-gradient-to-t to-transparent" />

//       <div className="absolute bottom-0 block px-6 py-4 text-white opacity-100 group-hover:opacity-0 ltr:left-0 rtl:right-0">
//         <p className="font-bold">{title}</p>
//       </div>

//       <div className="invisible absolute top-0 -translate-y-5 px-6 py-4 text-white opacity-0 transition duration-500 ease-in-out group-hover:visible group-hover:translate-y-0 group-hover:transform group-hover:opacity-100">
//         <p className="font-bold">{title}</p>
//       </div>
//       <div className="invisible absolute top-2 z-10 h-32 w-32 -translate-y-5 p-2 opacity-0 transition duration-500 ease-in-out group-hover:visible group-hover:translate-y-0 group-hover:transform group-hover:opacity-100 lg:h-16 lg:w-16 ltr:right-2 rtl:left-2">
//         <img
//           src={icon}
//           alt={title}
//         />
//       </div>
//       <div className="invisible absolute bottom-0 left-0 right-0 translate-y-5 p-4 text-white opacity-0 transition duration-500 ease-in-out group-hover:visible group-hover:translate-y-0 group-hover:transform group-hover:opacity-100">
//         <div class="flex flex-col gap-2 font-bold">
//           {clean_energy_item && (
//             <Link
//               to={clean_energy_item.link}
//               className="flex items-center border-2 border-cleanEnergy bg-white text-cleanEnergy hover:bg-cleanEnergy hover:text-white"
//             >
//               <div className="bg-cleanEnergy p-2">
//                 <CleanEnergyMineralIcon
//                   size={22}
//                   color={'#ffffff'}
//                 />
//               </div>
//               <div className="whitespace-nowrap ltr:pl-4 ltr:pr-8 rtl:pl-8 rtl:pr-4">{clean_energy_item.label}</div>
//             </Link>
//           )}
//           <Link
//               to={security_item.link}
//               className="flex items-center border-2 border-cleanEnergy bg-white text-cleanEnergy hover:bg-cleanEnergy hover:text-white"
//             >
//               <div className="bg-cleanEnergy p-2">
//                 <SecurityMineralIcon
//                   size={22}
//                   color={'#ffffff'}
//                 />
//               </div>
//               <div className="whitespace-nowrap ltr:pl-4 ltr:pr-8 rtl:pl-8 rtl:pr-4">{security_item.label}</div>
//             </Link>
//           )}
//           {industrial_item && industrial_item.link ? (
//             <Link
//               to={industrial_item.link}
//               className="flex items-center border-2 border-industrial bg-white text-industrial hover:bg-industrial hover:text-white"
//             >
//               <div className="bg-industrial p-2">
//                 <IndustrialMineralsIcon
//                   size={22}
//                   color={'#ffffff'}
//                 />
//               </div>
//               <div className="whitespace-nowrap ltr:pl-4 ltr:pr-8 rtl:pl-8 rtl:pr-4">{industrial_item.label}</div>
//             </Link>
//           ) : (
//             <div className="flex cursor-default items-center border-2 border-industrial/20 bg-white/20 text-industrial/70">
//               <div className="bg-industrial/20 p-2">
//                 <IndustrialMineralsIcon
//                   size={22}
//                   color={'#ffffff'}
//                 />
//               </div>
//               <div className="whitespace-nowrap ltr:pl-4 ltr:pr-8 rtl:pl-8 rtl:pr-4">{industrial_item.label}</div>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   )
// }



































import { Link } from 'react-router-dom'
import CleanEnergyMineralIcon from '../../icons/CleanEnergyMineralIcon'
import IndustrialMineralsIcon from '../../icons/IndustrialMineralsIcon'
import SecurityMineralIcon from '../../icons/SecurityMineralIcon'

export default function HomeOverviewGridCard({ title, image, clean_energy_item, industrial_item, security_item, icon }) {
  function insertLineBreak(text, limit) {
    if (!text) return ''
    if (text.length <= limit) return text
    return text.slice(0, limit) + '\n' + text.slice(limit)
  }

  return (
    <div
      data-aos="fade-down"
      className="border-primary-600 group relative col-span-12 h-[360px] overflow-hidden border-2 sm:col-span-6 lg:col-span-3 lg:h-[260px]"
    >
      <img
        src={image}
        alt={title}
        className="absolute h-full w-full object-cover transition duration-300 ease-in-out group-hover:scale-110"
      />
      <div className="from-primary-600 group-hover:to-primary-600/45 group-hover:via-primary-600/70 absolute h-full w-full bg-gradient-to-t to-transparent" />

      <div className="absolute bottom-0 block px-6 py-4 text-white opacity-100 group-hover:opacity-0 ltr:left-0 rtl:right-0">
        <p className="font-bold">{title}</p>
      </div>

      <div className="invisible absolute top-0 -translate-y-5 px-6 py-4 text-white opacity-0 transition duration-500 ease-in-out group-hover:visible group-hover:translate-y-0 group-hover:transform group-hover:opacity-100">
        <p className="font-bold whitespace-pre-line break-words leading-snug text-sm">
          {insertLineBreak(title, 20)}
        </p>
      </div>

      <div className="invisible absolute top-2 z-10 h-32 w-32 -translate-y-5 p-2 opacity-0 transition duration-500 ease-in-out group-hover:visible group-hover:translate-y-0 group-hover:transform group-hover:opacity-100 lg:h-16 lg:w-16 ltr:right-2 rtl:left-2">
        <img src={icon} alt={title} />
      </div>

      <div className="invisible absolute bottom-0 left-0 right-0 translate-y-5 p-4 text-white opacity-0 transition duration-500 ease-in-out group-hover:visible group-hover:translate-y-0 group-hover:transform group-hover:opacity-100">
        <div className="flex flex-col gap-2 font-bold">
          {clean_energy_item && (
            <Link
              to={clean_energy_item.link}
              className="flex items-center border-2 border-cleanEnergy bg-white text-cleanEnergy hover:bg-cleanEnergy hover:text-white"
            >
              <div className="bg-cleanEnergy p-2">
                <CleanEnergyMineralIcon size={22} color="#ffffff" />
              </div>
              <div className="whitespace-nowrap text-xs ltr:pl-4 ltr:pr-8 rtl:pl-8 rtl:pr-4">
                {clean_energy_item.label}
              </div>
            </Link>
          )}

          {industrial_item && industrial_item.link ? (
            <Link
              to={industrial_item.link}
              className="flex items-center border-2 border-industrial bg-white text-industrial hover:bg-industrial hover:text-white"
            >
              <div className="bg-industrial p-2 ">
                <IndustrialMineralsIcon size={22} color="#ffffff" />
              </div>
              <div className="whitespace-nowrap text-xs ltr:pl-4 ltr:pr-8 rtl:pl-8 rtl:pr-4">
                {industrial_item.label}
              </div>
            </Link>
          ) : (
            industrial_item && (
              <div className="flex cursor-default items-center border-2 border-industrial/20 bg-white/20 text-industrial/70">
                <div className="bg-industrial/20 p-2">
                  <IndustrialMineralsIcon size={22} color="#ffffff" />
                </div>
                <div className="whitespace-nowrap text-xs ltr:pl-4 ltr:pr-8 rtl:pl-8 rtl:pr-4">
                  {industrial_item.label}
                </div>
              </div>
            )
          )}

          {security_item && security_item.link ? (
            <Link
              to={security_item.link}
              className=" flex items-center border-2 border-security bg-white text-security hover:bg-security hover:text-white"
            >
                <img
                  src="/assets/icons/security-color-header/security-food-icon.svg"
                  alt=""
                  className="h-[37px] w-[37px] bg-security p-2"
                />
              
              <div className="whitespace-nowrap text-xs ltr:pl-4 ltr:pr-8 rtl:pl-8 rtl:pr-4">
                {security_item.label}
              </div>
            </Link>
          ) : (
            security_item && (
              <div className="flex cursor-default items-center border-2 border-security/20 bg-white/20 text-security/70">
                  <img
                    src="/assets/icons/security-color-header/security-food-icon.svg"
                    alt=""
                    className="h-[37px] w-[37px] bg-security/20 p-2"
                  />
                <div className="whitespace-nowrap text-xs ltr:pl-4 ltr:pr-8 rtl:pl-8 rtl:pr-4">
                  {security_item.label}
                </div>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  )
}
